import _classCallCheck from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { Stack, Svg, TargetLine } from '@opengov/data-viz';
import { sortBy, throttle } from 'lodash';
import * as React from 'react';
import { Axis } from '../Axis';
import { AxisName } from '../AxisName';
import { labelFormatter } from '../Chart';
import { DEFAULT_Y_AXIS_LABEL_OFFSET, Y_AXIS_LABEL_BUFFER } from '../chartUtilities/constants';
import { MessageOverlay } from '../MessageOverlay';
import { TargetStatus } from '../TargetStatus';
import styles from './StackedBar.scss';
export var StackedBar = /*#__PURE__*/function (_React$Component) {
  _inherits(StackedBar, _React$Component);

  var _super = _createSuper(StackedBar);

  function StackedBar(props) {
    var _this;

    _classCallCheck(this, StackedBar);

    _this = _super.call(this, props);

    _this.measureChartContainer = function (element) {
      _this.chartContainer = element;
    };

    _this.handleChartResize = function () {
      if (_this.props.onChartResize && _this.chartContainer) {
        _this.props.onChartResize(_this.chartContainer.getBoundingClientRect());
      }
    };

    _this.handleXTickFormat = function (value) {
      var _this$props = _this.props,
          chartCalculations = _this$props.chartCalculations,
          xTickLabelFormatter = _this$props.xTickLabelFormatter;

      if (chartCalculations.orientation === 'vertical') {
        return labelFormatter(xTickLabelFormatter, chartCalculations, value);
      }

      return value !== undefined && xTickLabelFormatter && xTickLabelFormatter(value);
    };

    _this.handleYTickFormat = function (value) {
      var _this$props2 = _this.props,
          chartCalculations = _this$props2.chartCalculations,
          yTickLabelFormatter = _this$props2.yTickLabelFormatter;

      if (chartCalculations.orientation === 'vertical') {
        return value !== undefined && yTickLabelFormatter && yTickLabelFormatter(value);
      }

      return labelFormatter(yTickLabelFormatter, chartCalculations, value);
    };

    _this.handleStackClick = function (category, data) {
      return _this.props.onClick(category, data);
    };

    _this.handleChartResize = throttle(_this.handleChartResize, 128);
    return _this;
  }

  _createClass(StackedBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleChartResize);
      this.handleChartResize();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleChartResize);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          chartCalculations = _this$props3.chartCalculations,
          dataTest = _this$props3.dataTest,
          elementColorFor = _this$props3.elementColorFor,
          onElementEnter = _this$props3.onElementEnter,
          onElementLeave = _this$props3.onElementLeave,
          xAxisName = _this$props3.xAxisName,
          yAxisName = _this$props3.yAxisName,
          yTickMax = _this$props3.yTickMax,
          showOverlay = _this$props3.showOverlay,
          messageOverlayProps = _this$props3.messageOverlayProps,
          _this$props3$targetSt = _this$props3.targetStatuses,
          targetStatuses = _this$props3$targetSt === void 0 ? [] : _this$props3$targetSt,
          targetValueFormatter = _this$props3.targetValueFormatter;
      var coordinateSystem = chartCalculations.coordinateSystem,
          dimensions = chartCalculations.dimensions,
          margin = chartCalculations.margin,
          orientation = chartCalculations.orientation,
          stackedData = chartCalculations.stackedData,
          xScale = chartCalculations.xScale,
          yScale = chartCalculations.yScale,
          yTickLabelWidth = chartCalculations.yTickLabelWidth,
          xTickLabelWidth = chartCalculations.xTickLabelWidth,
          xTickLabelHeight = chartCalculations.xTickLabelHeight;
      return React.createElement("div", {
        ref: this.measureChartContainer,
        "data-test": dataTest,
        className: orientation === 'vertical' ? styles.fixedHeight : undefined
      }, showOverlay && this.chartContainer && React.createElement(MessageOverlay, Object.assign({}, messageOverlayProps, {
        leftMargin: margin.left,
        width: this.chartContainer.getBoundingClientRect().width - DEFAULT_Y_AXIS_LABEL_OFFSET - margin.left
      })), React.createElement(Svg, {
        width: coordinateSystem.width,
        height: coordinateSystem.height,
        coordinateSystem: coordinateSystem
      }, React.createElement("g", {
        transform: "translate(".concat(margin.left, ", ").concat(margin.top, ")")
      }, React.createElement(Stack, {
        elementColorFor: elementColorFor,
        orientation: orientation,
        stackedData: stackedData,
        style: {
          stack: styles
        },
        xScale: xScale,
        yScale: yScale,
        onElementClick: this.handleStackClick,
        onElementEnter: onElementEnter,
        onElementLeave: onElementLeave
      }), React.createElement("g", {
        className: "y-axis"
      }, React.createElement(AxisY, {
        dimmed: showOverlay,
        orientation: orientation,
        xScale: xScale,
        yScale: yScale,
        yAxisName: yAxisName,
        yTickLabelWidth: yTickLabelWidth,
        handleYTickFormat: this.handleYTickFormat,
        approximateNumberOfTicks: yTickMax
      })), React.createElement("g", {
        className: "x-axis"
      }, React.createElement(AxisX, {
        dimmed: showOverlay,
        orientation: orientation,
        dimensions: dimensions,
        xScale: xScale,
        yScale: yScale,
        xTickLabelHeight: xTickLabelHeight,
        xTickLabelWidth: xTickLabelWidth,
        xAxisName: xAxisName,
        handleXTickFormat: this.handleXTickFormat
      })), React.createElement("g", {
        className: "targets",
        "data-test": "targets"
      }, sortBy(targetStatuses, function (s) {
        return s.value;
      }).map(function (target, index) {
        var scaleValue = orientation === 'vertical' ? yScale(target.value) : xScale(target.value);
        return React.createElement("g", {
          className: "target",
          key: "target-".concat(target.operator, "-").concat(target.value)
        }, React.createElement(TargetLine, {
          style: styles.targetLine,
          orientation: orientation,
          value: scaleValue,
          dimensions: dimensions
        }), React.createElement(TargetStatus, {
          dataTest: "target-status-".concat(index),
          verticalAlignment: targetStatuses.length > 1 ? index > 0 ? 'top' : 'bottom' : 'middle',
          orientation: orientation,
          textAnchor: orientation === 'horizontal' ? targetStatuses.length > 1 ? index > 0 ? 'start' : 'end' : 'middle' : 'start',
          config: target,
          x: orientation === 'vertical' ? dimensions.width + 8 : scaleValue,
          y: orientation === 'vertical' ? scaleValue : dimensions.height,
          valueFormatter: targetValueFormatter
        }));
      })))));
    }
  }]);

  return StackedBar;
}(React.Component);

function AxisY(_ref) {
  var orientation = _ref.orientation,
      yAxisName = _ref.yAxisName,
      xScale = _ref.xScale,
      yScale = _ref.yScale,
      handleYTickFormat = _ref.handleYTickFormat,
      yTickLabelWidth = _ref.yTickLabelWidth,
      approximateNumberOfTicks = _ref.approximateNumberOfTicks,
      dimmed = _ref.dimmed;

  switch (orientation) {
    case 'horizontal':
      return React.createElement(React.Fragment, null, React.createElement(AxisName.UnrotatedY, {
        text: yAxisName,
        x: -Y_AXIS_LABEL_BUFFER,
        dimmed: dimmed,
        y: "0",
        dy: "-0.35em"
      }), React.createElement(Axis.Band.Y, {
        dimmed: dimmed,
        tickLabelFormatter: handleYTickFormat,
        xScale: xScale,
        yScale: yScale
      }));

    default:
      return React.createElement(React.Fragment, null, React.createElement(AxisName.Y, {
        text: yAxisName,
        x: -50,
        y: 0,
        dimmed: dimmed
      }), React.createElement(Axis.Y, {
        tickLabelFormatter: handleYTickFormat,
        dimmed: dimmed,
        xScale: xScale,
        yScale: yScale,
        approximateNumberOfTicks: approximateNumberOfTicks
      }));
  }
}

function AxisX(_ref2) {
  var orientation = _ref2.orientation,
      dimensions = _ref2.dimensions,
      xAxisName = _ref2.xAxisName,
      xTickLabelHeight = _ref2.xTickLabelHeight,
      xTickLabelWidth = _ref2.xTickLabelWidth,
      xScale = _ref2.xScale,
      yScale = _ref2.yScale,
      handleXTickFormat = _ref2.handleXTickFormat,
      dimmed = _ref2.dimmed;

  switch (orientation) {
    case 'horizontal':
      return React.createElement(React.Fragment, null, React.createElement(AxisName.X, {
        text: xAxisName,
        x: dimensions.width / 2,
        y: -30,
        dimmed: dimmed
      }), React.createElement(Axis.Top.X, {
        dimmed: dimmed,
        xTickLabelHeight: 0,
        xTickLabelWidth: xTickLabelWidth,
        tickLabelFormatter: handleXTickFormat,
        xScale: xScale,
        yScale: yScale
      }));

    default:
      return React.createElement(React.Fragment, null, React.createElement(AxisName.X, {
        dimmed: dimmed,
        text: xAxisName,
        x: dimensions.width / 2,
        y: dimensions.height + DEFAULT_Y_AXIS_LABEL_OFFSET
      }), React.createElement(Axis.Band.X, {
        dimmed: dimmed,
        xTickLabelWidth: xTickLabelWidth,
        tickLabelFormatter: handleXTickFormat,
        xScale: xScale,
        yScale: yScale
      }));
  }
}